import PropTypes from 'prop-types';
import React from "react";

export default function StarIcon({title, filled}) {
  return (
    <svg className={`star-icon${filled ? " filled" : ""}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 60">
      <title>{title}</title>
      <path d="M31.646 0l-7.43 22.94H0l19.81 14.12L12.093 60l19.552-14.217L51.2 60l-7.727-22.94 19.822-14.12H39.078L31.646 0z" transform="matrix(.8744 0 0 .865 4.343 4.51)" fillRule="evenodd"/>
    </svg>
  );
}

StarIcon.propTypes = {
  filled: PropTypes.bool,
  title: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./modules/Common/components/svg/StarIcon.js